import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "work-days-alert-modal-content work-days-alert-modal-container__work-days-alert-modal-content" }
const _hoisted_2 = { class: "text-container work-days-alert-modal-content__text-container" }
const _hoisted_3 = { class: "text-container__check-box" }
const _hoisted_4 = { class: "action-confirm-button-container" }

import { ref, watch } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import RowCheckBox from '../atom/RowCheckBox.vue';
import router from '@/router';
import { getCalendar } from '@/appLogic/checkCalendar';
import { putPreference } from '@/appLogic/preferenceManage';
import { simpleCopy } from '@/utils/deepCopy';
import { getOrganizationId } from '@/utils/token';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkDaysCalendarNotYetEnteredAlertModal',
  props: {
    isOpenModal: { type: Boolean }
  },
  emits: ["outside-click"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;

const emits = __emit;

const isShowModal = ref(false);
const isDisplayToday = ref(false);

// 親コンポーネントから渡ってきたopen/closeのフラグを監視する
watch(
  () => props.isOpenModal,
  () => {
    isShowModal.value = props.isOpenModal;
  }
);

const closeModal = () => {
  if (isDisplayToday.value) {
    putShowCalendarInfo(isDisplayToday.value);
  }
  isShowModal.value = false;
  emits('outside-click', false);
};

const sendCalendarPage = async () => {
  if (isDisplayToday.value) {
    putShowCalendarInfo(isDisplayToday.value);
  }
  await router.push('/calendar');
};

/**
 * 「今日は表示しない」チェックボックスの値と、チェック日時の登録を行う
 * @param checkboxStatus
 */
const putShowCalendarInfo = async (checkboxStatus: boolean) => {
  const calendar = simpleCopy(await getCalendar());
  calendar.unRegisterCalendarAlert.updateAt = Math.floor(new Date().getTime() / 1000);
  calendar.updatedAt = Math.floor(new Date().getTime() / 1000);
  calendar.unRegisterCalendarAlert.isDisplay = !checkboxStatus;
  calendar.workDays.sort(DateService.compareYearMonths);
  await putPreference(await getOrganizationId(), 'calendar', calendar).catch((err) => console.log('err', err));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "work-days-alert-modal-container",
    "modal-size": 480,
    "aspect-ratio": true,
    "stretch-container": true,
    "scroll-off": true,
    padding: '16px',
    "modal-state": props.isOpenModal,
    onOutsideClick: _cache[2] || (_cache[2] = ($event: any) => (closeModal()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "work-days-alert-modal-content__title" }, [
          _createElementVNode("div", null, "稼働日カレンダーを登録してください。"),
          _createElementVNode("div", null, "Please register working calender.")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-container__text-content" }, [
            _createTextVNode(" 稼働日が5日以下の月が存在しています。"),
            _createElementVNode("br"),
            _createTextVNode(" There are months with less than 6 working days. ")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(RowCheckBox, {
              "is-checked": isDisplayToday.value,
              onChangeStatus: _cache[0] || (_cache[0] = ($event: any) => (isDisplayToday.value = $event))
            }, null, 8, ["is-checked"]),
            _cache[3] || (_cache[3] = _createTextVNode(" 本日は表示しない Don't show today "))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextButton, {
            color: 'primary',
            size: 'btn-md',
            class: "action-confirm-button-container__action-confirm-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (sendCalendarPage()))
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" 稼働日カレンダーを登録"),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" Register working calender ")
            ]), undefined, true),
            _: 1,
            __: [5]
          })
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})